class SpliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.options = JSON.parse(this.dataset.options);
    new Splide(this, this.options).mount();
  }
}
customElements.define("splider-component", SpliderComponent);


window['variantSwatches'] = () => {
  return {
    firstVisible: true,
    lastVisible: false,
    mounted() {
      const firstThumbnail = this.$refs.firstThumbnail;
      const lastThumbnail = this.$refs.lastThumbnail;
      const options = {
        root: this.$root.querySelector('.variant-options-container'),
        rootMargin: '0px',
        threshold: 1.0,
      };
      const firstThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.firstVisible = true;
          } else {
            this.firstVisible = false;
          }
        },
        options
      );
      const lastThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.lastVisible = true;
          } else {
            this.lastVisible = false;
          }
        },
        options
      );
      firstThumbnailObserver.observe(firstThumbnail);
      lastThumbnailObserver.observe(lastThumbnail);
    },
  };
};

function handleCartUpsellChange(e) {
  const data = e.detail.response
  const upsellHTML = parseDOMFromString(data.sections['cart-upsell-dynamic'])
  if (document.querySelector('.cart-dynamic-upsell--wrapper')) {
    document.querySelector('.cart-dynamic-upsell--wrapper').innerHTML = upsellHTML.querySelector('.cart-dynamic-upsell--wrapper').innerHTML
  }
}

window.addEventListener('shapes:modalcart:afteradditem', (e) => handleCartUpsellChange(e))
window.addEventListener('shapes:modalcart:cartqtychange', (e) => handleCartUpsellChange(e))

class CartUpsellRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.cards = []
    this.cartUpsell();
    this.toggleButton = null
    this.splide = null
  }

  getUniqueNodes(array) {
    let uniqueNodes = [];

    array.forEach(node => {
      if (!uniqueNodes.some(uniqueNode => uniqueNode.isEqualNode(node))) {
        uniqueNodes.push(node);
      }
    });
    return uniqueNodes;
  }


  async cartUpsell() {
    document.querySelector("cart-upsell-recommendations").innerHTML = "";
    let productIds = document.querySelector("cart-upsell-recommendations").getAttribute("data-product-id").split(",");
    if (productIds.length === 0) {
      return
    }
    const urls = productIds.map(id => `/recommendations/products?product_id=${id}&section_id=upsell-recommendations&intent=related`);
    const responses = await Promise.all(urls.map(url => {
      return fetch(url)
    }));
    let hasRecommendation = false;

    for (let i = 0; i < responses.length; i++) {
      const response = responses[i];
      const text = response.status == 200 ? await response.text() : "null";
      const html = document.createElement('div');
      html.innerHTML = text;

      if (html.querySelector('#shopify-section-upsell-recommendations').innerHTML.trim() !== '') {
        hasRecommendation = true;
        let uniq = this.getUniqueNodes(this.makeMarkupHtml(html, "app"))
        uniq.forEach((un) => {
          let id = un.getAttribute('data-product-id')
          this.cards.push({
            id,
            html: un.outerHTML
          })
        })
      }
    }
    const filteredArray = this.cards.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        acc.push(current);
      }
      return acc;
    }, []);
    if (filteredArray.length === 0) {
      document.querySelector('cart-upsell-recommendations').style.display = 'none'
    }
    this.buildSliderWithCards(filteredArray)
    this.splide = this.querySelector('splider-component.cart-upsell-slider')

  }

  buildSliderWithCards(cards) {

    const arrow = `<button class="toggle-upsell"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 25 24" width="24" heigh="24" fill="none">
      <path d="M20.4549 9.53104L12.9549 17.031C12.8852 17.1008 12.8025 17.1561 12.7115 17.1938C12.6204 17.2316 12.5228 17.251 12.4242 17.251C12.3257 17.251 12.2281 17.2316 12.137 17.1938C12.046 17.1561 11.9633 17.1008 11.8936 17.031L4.39362 9.53104C4.25289 9.39031 4.17383 9.19944 4.17383 9.00042C4.17383 8.80139 4.25289 8.61052 4.39362 8.46979C4.53435 8.32906 4.72522 8.25 4.92425 8.25C5.12327 8.25 5.31414 8.32906 5.45487 8.46979L12.4242 15.4401L19.3936 8.46979C19.4633 8.40011 19.546 8.34483 19.6371 8.30712C19.7281 8.26941 19.8257 8.25 19.9242 8.25C20.0228 8.25 20.1204 8.26941 20.2114 8.30712C20.3025 8.34483 20.3852 8.40011 20.4549 8.46979C20.5246 8.53947 20.5798 8.6222 20.6175 8.71324C20.6553 8.80429 20.6747 8.90187 20.6747 9.00042C20.6747 9.09896 20.6553 9.19654 20.6175 9.28759C20.5798 9.37863 20.5246 9.46136 20.4549 9.53104Z" fill="black"/>
      </svg></button>`

    const splideCode = `<div class="cart-upsell--wrapper overflow-hidden">
    <h2 class="flex justify-between items-center py-2 text-xl sm:text-lg font-heading">You may also like</h2>
    <splider-component
      class="cart-upsell-slider block splide"
      data-options='{
      "type":"slide",
      "arrows":true ,
      "pagination":false ,
      "perMove":1 ,
      "fixedWidth": "140px",
      "trimSpace": true ,
      "mediaQuery": "min",
      "gap":"1.21rem",
      "drag":true,
      "breakpoints" : {
        "768": {
          "fixedWidth": "150px",
          "perMove":1,
          "arrows": false   
          }
        }
      }'
    >
      <div class="splide__track">
        <ul class="splide__list" role="list">
        ${cards.map((card) => {
      return `<li
              class="splide__slide"
            >
              ${card.html}
            </li>`
    }).join('')}
            
        </ul>
      </div>
      </splider-component>
</div>`
    document.querySelector('cart-upsell-recommendations').innerHTML = splideCode
  }

  makeMarkupHtml(html, productOrigin) {
    let upsellData = html.querySelector(".cards--wrapper")?.innerHTML;
    return html.querySelectorAll('.product-tile.product-card')
  }
}
customElements.define('cart-upsell-recommendations', CartUpsellRecommendations);

class CalculatedPrice extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.addEventListener('priceChange', () => {
      setTimeout(this.updatePrice, 300)
    })
  }

  updatePrice() {
    const priceElement = document.querySelector('calculated-price')
    const inputELement = document.querySelector('input.quantity-input')
    const priceContainer = priceElement.querySelector('.updated-price')

    const quantity = parseInt(inputELement.dataset.value)
    const price = parseInt(inputELement.dataset.price) / 100
    const totalPrice = quantity * price
    priceContainer.innerHTML = `Total Price : ₹ ${totalPrice}`
  }
}

customElements.define('calculated-price', CalculatedPrice)



// Readmore content  functionality for homepage and collection pages
document.addEventListener("DOMContentLoaded", function () {
  const readMoreButton = document.getElementById('read-more-button');
  const readLessButton = document.getElementById('read-less-button');
  const contentToToggle = document.querySelector('.content-toggle');

  readMoreButton?.addEventListener('click', function () {
    contentToToggle.classList.toggle('content-hidden');
    readMoreButton.classList.toggle('content-hidden');
    readLessButton.classList.toggle('content-hidden');
  });

  readLessButton?.addEventListener('click', function () {
    readMoreButton.click();
  });
});



//to sync PDP images and thumbnails active state
const productThumnailSlideId = document.querySelector('.splide.splide--product')?.id
setTimeout(()=>{
  const productThumbnailSlide = window.slideshows[productThumnailSlideId]
  let activeMediaId
  if(productThumbnailSlide){
    productThumbnailSlide.on('mounted moved', (newIndex) => {
      // Get the active slide element
      const activeSlide = productThumbnailSlide?.Components.Slides.getAt(newIndex).slide;
      activeMediaId = activeSlide.dataset.mediaId
      window.dispatchEvent(new CustomEvent('carousel-moved', { detail: { mediaId: parseInt(activeMediaId) } }));
    });
  }
},1000)

const CartButton = document.getElementById("CartButton");
const sticky_nav_cart = document.getElementById("sticky_nav_cart");
CartButton?.addEventListener("click", ()=> {
  document.body.classList.add("cart_open");
  typeof(renderPopPrices)==='function' && renderPopPrices();
})
sticky_nav_cart.addEventListener("click", ()=> {
  document.body.classList.add("cart_open");
  typeof(renderPopPrices)==='function' && renderPopPrices();
})


let mql = window.matchMedia("(max-width: 768px)");

if (mql.matches) {
  window.addEventListener('scroll', () => {
    const nav = document.querySelector('.mobile-sticky-nav');
    const pop = document.querySelector('.pop-star1');

    if (!nav || !pop) return;

    if (nav.classList.contains('hidden')) {
      pop.style.setProperty('bottom', '0px');
    } else {
      pop.style.setProperty('bottom', '53.4px');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  let clearIntervalId;

  function fetchPagination(pdpMainProductContainerEl, featuredMediaHeight) {
    const paginationEl = pdpMainProductContainerEl.querySelector('.splide__pagination');
    if (paginationEl) {
      paginationEl.style.top = `${featuredMediaHeight + 5}px`;
      clearInterval(clearIntervalId);
    }
  }

  function alignPaginationToBottomOfFeaturedMedia() {
    const pdpMainProductContainerEl = document.querySelector('.product-wrapper-container');
    const featuredMedia = pdpMainProductContainerEl.querySelector('.feature-media-list');
    const featuredMediaHeight = featuredMedia.getBoundingClientRect().height;
    clearIntervalId = setInterval(function () {
      fetchPagination(pdpMainProductContainerEl, featuredMediaHeight)
    }, 1000);
    setTimeout(function(){
      clearInterval(clearIntervalId);
    }, 20000)
  }

  if (location.pathname.includes('/products/')) {
    alignPaginationToBottomOfFeaturedMedia();

    const PhotoSwipeContainer = document.getElementById('PhotoSwipeContainer');
    const headerSection = document.querySelector('.shopify-section.shopify-section-group-header-group.section-site-header');

    if (PhotoSwipeContainer && headerSection) {
      const observer = new MutationObserver(() => {
        if (PhotoSwipeContainer.children.length > 0) {
          headerSection.classList.add('header-hidden-during-photoswipe');
        } else {
          headerSection.classList.remove('header-hidden-during-photoswipe');
        }
      });

      observer.observe(PhotoSwipeContainer, { childList: true });
    }
  }
});
